import { DefinitionTooltipConfig } from 'src/components/Tooltip/DefinitionTooltip/types';
import Link from 'src/components/primitives/Link/Link';

const settingsTooltips = {
	settingsDuration: {
		title: 'Duration',
		body: 'The amount of time the auction lasts for. A single slot is approximately 0.5 sec.',
	},
	settingsPlaceAndTake: {
		title: 'Place And Take',
		body: (
			<>
				<p>
					Place And Take lets you atomically fill up to your size vs. maker
					orders until the auction end price.
				</p>
				<p>
					This applies to market orders and is meant to provide faster + more
					predictable fills.
				</p>
				<p>
					Any portion of the order size leftover goes through normal auction.
					Requires versioned transactions.
				</p>
			</>
		),
	},
	settingsOracleAuctions: {
		title: 'Oracle Auctions',
		body: (
			<>
				<p>
					For Market orders, the auction parameters above will automatically be
					based on offsets from the Oracle Price. This doesn&apos;t apply to
					Stop Market or Take Profit Market orders.
				</p>
				<Link
					href="https://docs.drift.trade/trading/auction-parameters"
					openInNewTab
				>
					Learn more
				</Link>
			</>
		),
	},
	settingsAccountSubscriptionType: {
		title: 'Account Subscription Type',
		body: 'Controls whether the Drift Client / RPC connects using websockets or polling. This affects things like subscriptions to the current user account state, how orderbook data is pulled from chain, etc.',
	},
	settingsGlobalEventsSubscription: {
		title: 'Global Events Subscription',
		body: 'Controls the subscription to global events relevant to the UI, currently this is only trades for the current market!',
	},
	settingsUserEventsSubscription: {
		title: 'User Events Subscription',
		body: 'Controls the subscription to onchain events relevant for the CURRENT USER (e.g. all of their trades, orders, deposits, etc.).',
	},
	settingsMaxLeverage: {
		title: 'Max Leverage',
		body: 'This is the max initial margin allowed based on weighted assets/liabilities',
	},
	settingsReduceOnly: {
		title: 'Account Level Reduce Only',
		body: 'Safety measure that ensures the account can only reduce positions.',
	},
	settingsVersionedTx: {
		title: 'Versioned Transactions',
		body: (
			<>
				<p>
					It is recommended to use versioned transactions, although some wallets
					may not support them - in which case you should turn them off.
				</p>
				<Link
					href="https://docs.drift.trade/trading/versioned-transactions"
					openInNewTab
				>
					Learn more
				</Link>
			</>
		),
	},
} as const satisfies Record<string, DefinitionTooltipConfig>;

const feeTierTooltips = {
	feeTierMakerRebate: {
		title: 'Maker Rebate',
		body: 'Earn rebates by placing post only limit orders.',
	},
} as const satisfies Record<string, DefinitionTooltipConfig>;

const depositFromOtherSourcesTooltips = {
	depositFromOtherSourcesMinimumDeposit: {
		title: 'Minimum Deposit',
		body: 'The minimum deposit amount required for the selected asset and chain.',
	},
	depositFromOtherSourcesReceivingAddress: {
		title: 'Receiving Address',
		body: 'Send any accepted asset to this address and it will automatically bridge, swap, and deposit to your Drift Account.',
	},
	depositFromOtherSourcesPriceImpact: {
		title: 'Price Impact',
		body: 'Reflects the difference between expected and execution price, factoring in trade size, liquidity, and slippage during execution. Estimated based on $100k transfer.',
	},
} as const satisfies Record<string, DefinitionTooltipConfig>;

export const modalTooltips = {
	...settingsTooltips,
	...feeTierTooltips,
	...depositFromOtherSourcesTooltips,
};
